import React from "react";
import { Message as BasisMessage } from "basis";
import styled, { css } from "styled-components";
import { COLOR } from "./theme";

const StyledWrapper = styled.div`
  ${(props) =>
    props.color && css`
    p,
    strong {
      color: ${props.color};
    }

    svg path {
      fill: ${props.color};
    }
  `}
  ${(props) =>
    props.bg === "yellow.t10" ?
    css`
      div:first-child {
        background-color: ${COLOR.YELLOW_LIGHT};
      }
    ` :  
    css`
      div:first-child {
        background-color: ${props.bg};
      }
    `
  }

  ${(props) =>
    props.fontFamily &&
    css`
     p,
      strong {
        font-family: ${props.fontFamily}, sans-serif;
        font-size: 14px;
      }
    `}
`;

export const Message = ({ bg, color, fontFamily, ...props }) => {
  // TODO: use basis when "yellow.t10" is supported

  return (
    <StyledWrapper bg={bg} color={color} fontFamily={fontFamily}>
      <BasisMessage {...props} />
    </StyledWrapper>
  );
};
